'use client';

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Wrapper component for FontAwesome icons
 * @param {Object} props - Component props
 * @param {import('@fortawesome/fontawesome-svg-core').IconDefinition} props.icon - Font Awesome icon definition
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.size - Icon size (sm, lg, 2x, 3x, etc.)
 * @param {boolean} props.spin - Whether the icon should spin
 * @param {boolean} props.pulse - Whether the icon should pulse
 * @param {string} props.color - Text color class (e.g., 'text-blue-500')
 * @param {React.CSSProperties} props.style - Inline styles
 * @returns {JSX.Element}
 */
const Icon = ({ 
  icon, 
  className = '', 
  size = '', 
  spin = false, 
  pulse = false,
  color = '',
  style = {},
  ...props 
}) => {
  const sizeClass = size ? `fa-${size}` : '';
  const colorClass = color || 'text-gray-700';
  
  return (
    <FontAwesomeIcon data-component-id="src\components\ui\FontAwesomeIcon.jsx:32:4" data-component-path="src\components\ui\FontAwesomeIcon.jsx" data-component-line="32" data-component-end-line="39" data-component-file="FontAwesomeIcon.jsx" data-component-name="FontAwesomeIcon" data-component-content="%7B%22elementName%22%3A%22FontAwesomeIcon%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
      icon={icon}
      className={`${sizeClass} ${colorClass} ${className}`}
      spin={spin}
      pulse={pulse}
      style={style}
      {...props}
    />
  );
};

export default Icon;
